module.exports = __webpack_public_path__ + "img/DAY2-2.17ebd3fe.jpg";